import { render } from "./ChargebeeUpsellConfig.vue?vue&type=template&id=1235ff50&scoped=true"
import script from "./ChargebeeUpsellConfig.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellConfig.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellConfig.vue?vue&type=style&index=0&id=1235ff50&lang=scss"
import "./ChargebeeUpsellConfig.vue?vue&type=style&index=1&id=1235ff50&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1235ff50"]])

export default __exports__